"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@emotion/core");

var _lodash = require("lodash");

var _window = _interopRequireDefault(require("global/window"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 14px;\n    position: absolute;\n    padding: 4px;\n    margin: 8px;\n    background: rgba(0, 0, 0, 0.75);\n    color: #ffffff;\n    // max-width: 250px;\n    max-width: ", ";\n    z-index: 9;\n    pointer-events: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var MapTooltip = function MapTooltip(props) {
  var x = props.x,
      y = props.y,
      formatPrimaryField = props.formatPrimaryField,
      formatSecondaryField = props.formatSecondaryField,
      isHex = props.isHex,
      isScreenGrid = props.isScreenGrid,
      primaryName = props.primaryName,
      primaryField = props.primaryField,
      secondaryName = props.secondaryName,
      secondaryField = props.secondaryField,
      tooltipDataArray = props.tooltipDataArray,
      tooltipInfo = props.tooltipInfo,
      wide = props.wide;
  var tooltip = (0, _core.css)(_templateObject(), wide ? "400px" : "250px");
  var xPosition = x < (0, _lodash.get)(_window["default"], "innerWidth", 1000) * 0.66 ? x : x - (0, _lodash.get)(_window["default"], "innerWidth", 1000) * 0.1;
  var yPosition = y < 375 ? y : y - 50;

  var getProperty = function getProperty(property, formatFunction) {
    if (formatFunction) {
      return formatFunction(property);
    }

    return property;
  };

  return (0, _core.jsx)("div", {
    css: tooltip,
    style: {
      left: xPosition,
      top: yPosition
    }
  }, primaryName && (0, _core.jsx)("div", null, (0, _core.jsx)("strong", null, "".concat(primaryName, ": ")), getProperty(tooltipInfo.properties[primaryField], formatPrimaryField)), secondaryName && (0, _core.jsx)("div", null, (0, _core.jsx)("strong", null, "".concat(secondaryName, ": ")), getProperty(tooltipInfo.properties[secondaryField], formatSecondaryField)), !isScreenGrid && tooltipDataArray.map(function (el) {
    return (0, _core.jsx)("div", {
      key: el.name
    }, (0, _core.jsx)("strong", null, "".concat(el.name, ": ")), getProperty(tooltipInfo.properties[el.field], el.formatField));
  }), isScreenGrid && tooltipDataArray.map(function (el) {
    return (0, _core.jsx)("div", {
      key: el.name
    }, (0, _core.jsx)("strong", null, "".concat(el.name, ": ")), !el.totalField && getProperty(tooltipInfo[el.field], el.formatField), el.totalField && getProperty(tooltipInfo[el.field] / tooltipInfo[el.totalField], el.formatField));
  }), isHex && (0, _core.jsx)("div", null, (0, _core.jsx)("div", null, "elevation: ", tooltipInfo.elevationValue), (0, _core.jsx)("div", null, "coordinates: ", tooltipInfo.centroid.join(", "))));
};

MapTooltip.propTypes = {
  tooltipInfo: _propTypes["default"].shape({}),
  x: _propTypes["default"].number,
  y: _propTypes["default"].number,
  formatPrimaryField: _propTypes["default"].func,
  formatSecondaryField: _propTypes["default"].func,
  primaryName: _propTypes["default"].string,
  primaryField: _propTypes["default"].string,
  secondaryName: _propTypes["default"].string,
  secondaryField: _propTypes["default"].string,
  tooltipDataArray: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    field: _propTypes["default"].string.isRequired,
    totalField: _propTypes["default"].string,
    formatField: _propTypes["default"].func
  })),
  isHex: _propTypes["default"].bool,
  isScreenGrid: _propTypes["default"].bool,
  wide: _propTypes["default"].bool
};
MapTooltip.defaultProps = {
  formatPrimaryField: null,
  formatSecondaryField: null,
  tooltipDataArray: [],
  wide: false
};
var _default = MapTooltip;
exports["default"] = _default;